import React from "react"
import ListItem from './ListItem'
import {REDEEMPAGE_STRINGS} from '../Strings';


const Pending_Redeem=()=>{

 const accordionData = [
        {
            title: "30-May-2020 - Amount:3000",
          RedeemDetails: [
            { title:"Redeem Option", Status: 'Andra Bank' },
                { title:"A/C Details" , Status: "*********2017" },
                { title:"Request Id" , Status : "100000" },
                { title:"Processor" , Status: "Online Transfer" },
                { title:"Status " , Status: "Processing" },
          ]
        },
        {
            title: "27-May-2020 - Amount:3000",
            RedeemDetails: [
              { title:"Redeem Option", Status: 'Andra Bank' },
              { title:"A/C Details" , Status: "*********2017" },
              { title:"Request Id" , Status : "100000" },
              { title:"Processor" , Status: "Online Transfer" },
              { title:"Status " , Status: "Processing" },
            ]
          },
          {
            title: "28-May-2020 - Amount:5000",
            RedeemDetails: [
              { title:"Redeem Option", Status: 'Andra Bank' },
              { title:"A/C Details" , Status: "*********2017" },
              { title:"Request Id" , Status : "100000" },
              { title:"Processor" , Status: "Online Transfer" },
              { title:"Status " , Status: "Processing" },
            ]
          },
          {
            title: "28-May-2020 - Amount:5000",
            RedeemDetails: [
              { title:"Redeem Option", Status: 'Andra Bank' },
              { title:"A/C Details" , Status: "*********2017" },
              { title:"Request Id" , Status : "100000" },
              { title:"Processor" , Status: "Online Transfer" },
              { title:"Status " , Status: "Processing" },
            ]
          },
          {
            title: "28-May-2020 - Amount:5000",
            RedeemDetails: [
              { title:"Redeem Option", Status: 'Andra Bank' },
              { title:"A/C Details" , Status: "*********2017" },
              { title:"Request Id" , Status : "100000" },
              { title:"Processor" , Status: "Online Transfer" },
              { title:"Status " , Status: "Processing" },
            ]
          },
          {
            title: "28-May-2020 - Amount:5000",
            RedeemDetails: [
              { title:"Redeem Option", Status: 'Andra Bank' },
              { title:"A/C Details" , Status: "*********2017" },
              { title:"Request Id" , Status : "100000" },
              { title:"Processor" , Status: "Online Transfer" },
              { title:"Status " , Status: "Processing" },
            ]
          },
           {
            title: "28-May-2020 - Amount:5000",
            RedeemDetails: [
              { title:"Redeem Option", Status: 'Andra Bank' },
              { title:"A/C Details" , Status: "*********2017" },
              { title:"Request Id" , Status : "100000" },
              { title:"Processor" , Status: "Online Transfer" },
              { title:"Status " , Status: "Processing" },
            ]
          },
      ];
    
        return(
         <div className="w-100 center pt4 pa2-l" style={{ minHeight:'100vh'}}>
          
            <div className="w-100  pa4-l center mt3 ">
              {accordionData.map(({ title, RedeemDetails }) => (
                <ListItem title={title} RedeemDetails={RedeemDetails} />
              ))}
              <div className="w-100 tc center mt3  ba br2 b--solid b--black-90 ">
              <p className="f4-l f7-m f8-ns" style={{color:'#bad1d7'}}>{REDEEMPAGE_STRINGS.KEY_FOR_ANY_QURIES} <a className="light-blue underline" href="0">{REDEEMPAGE_STRINGS.KEY_REDEEM_INFO_MAIL} </a> {REDEEMPAGE_STRINGS.KEY_OR_CALL} <a className="light-blue underline" href="0">{REDEEMPAGE_STRINGS.KEY_REDEEM_INFO_MOBILE}</a>{REDEEMPAGE_STRINGS.KEY_CALL_CHARGES}</p></div>
               
              </div>
         
         </div>
          
         
        )
    
}
export default Pending_Redeem;